import type { ReactNode } from 'react';

export interface HandlePreviewProps {
  username: string;
  /**
   * 4-digit discriminator. When supplied, renders `#NNNN` (zero-padded);
   * when omitted (sign-up surface), renders `#----` to signal "assigned on
   * submit".
   */
  discriminator?: number | null;
  placeholder?: string;
  caption?: ReactNode;
  className?: string;
}

function formatSuffix(d: number): string {
  return `#${String(d).padStart(4, '0').slice(-4)}`;
}

export function HandlePreview({
  username,
  discriminator,
  placeholder = 'username',
  caption,
  className
}: HandlePreviewProps) {
  const display = username.trim() || placeholder;
  const isPlaceholder = !username.trim();
  const suffix =
    typeof discriminator === 'number' && Number.isFinite(discriminator)
      ? formatSuffix(discriminator)
      : '#----';
  return (
    <div className={['pn-handle', className].filter(Boolean).join(' ')} aria-live="polite">
      <span className="pn-handle-glyph">@</span>
      <span className={['pn-handle-typed', isPlaceholder ? 'pn-handle-typed-empty' : ''].filter(Boolean).join(' ')}>
        {display}
      </span>
      <span className="pn-handle-dashes">{suffix}</span>
      {caption ? <span className="pn-handle-caption">{caption}</span> : null}
    </div>
  );
}
